import React from 'react';
import Route from 'found/lib/Route';
import EstimateContainer from '../components/Document/Estimate/EstimateContainer';
import InvoiceContainer from '../components/Document/Invoice/InvoiceContainer';
import ContractContainer from '../components/Document/Contract/ContractContainer';
import FormContainer from '../components/Document/Form/FormContainer';
import MusicPlannerContainer from '../components/Document/MusicPlanner/MusicPlannerContainer';
import PlannerPlaylistContainer from '../components/Document/MusicPlanner/PlannerPlaylistContainer';
import { Loader } from '../components/Elements';
import { graphql } from 'react-relay';

const DocumentRoutes = (
  <Route path='docs'>
    <Route
      path='e/:id/:action?'
      Component={EstimateContainer}
      query={graphql`
        query DocumentRoutes_Estimate_Query($id: ID!) {
          node(id: $id) {
            ...EstimateContainer_node
          }
          viewer {
            ...EstimateContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <EstimateContainer {...props} /> : <Loader />)}
    />
    <Route
      path='i/:id/:action?'
      Component={InvoiceContainer}
      query={graphql`
        query DocumentRoutes_Invoice_Query($id: ID!) {
          node(id: $id) {
            ...InvoiceContainer_node
          }
          viewer {
            ...InvoiceContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <InvoiceContainer {...props} /> : <Loader />)}
    />
    <Route
      path='c/:id/:action?/:signer_id?'
      Component={ContractContainer}
      query={graphql`
        query DocumentRoutes_Contract_Query($id: ID!) {
          node(id: $id) {
            ...ContractContainer_node
          }
          viewer {
            ...ContractContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <ContractContainer {...props} /> : <Loader />)}
    />
    <Route
      path='f/:id/:action?'
      Component={FormContainer}
      query={graphql`
        query DocumentRoutes_Form_Query($id: ID!) {
          node(id: $id) {
            ...FormContainer_node
          }
          viewer {
            ...FormContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <FormContainer {...props} /> : <Loader />)}
    />
    <Route
      path='m/:id/:action?'
      Component={MusicPlannerContainer}
      query={graphql`
        query DocumentRoutes_MusicPlanner_Query($id: ID!) {
          node(id: $id) {
            ...MusicPlannerContainer_node
          }
          viewer {
            ...MusicPlannerContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <MusicPlannerContainer {...props} /> : <Loader />)}
    >
      <Route
        path='playlist/:playlist_id'
        Component={PlannerPlaylistContainer}
        query={graphql`
          query DocumentRoutes_PlannerPlaylist_Query($playlist_id :ID!) {
            node(id: $playlist_id) {
              ...PlannerPlaylistContainer_node @arguments(id: $playlist_id)
            }
            viewer {
              ...PlannerPlaylistContainer_viewer
            }
          }
        `}
        render={({ props }) => (props ? <PlannerPlaylistContainer {...props} /> : <Loader />)}
      />
    </Route>
  </Route>
);

export default DocumentRoutes;



// WEBPACK FOOTER //
// ./webpack/routes/DocumentRoutes.js